import { render } from "./WorkForm.vue?vue&type=template&id=28acecb3"
import script from "./WorkForm.vue?vue&type=script&lang=js"
export * from "./WorkForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__